<template>
  <div class="next-app" @wheel.prevent="onWheel" @touchstart="onTouchStart" @touchend="onTouchEnd">
    <header class="next-header">
      <div class="header-gradient"></div>
      <div class="header-inner">
        <a class="logo-area" href="/">
          <img :src="logoImg" alt="ChaCha" class="logo-icon" />
          <span class="logo-text">ChaCha</span>
        </a>
        <div class="header-app-wrap">
          <a class="header-app-btn" href="javascript:;">
            <img src="../../common/imgs/icon-download.png" alt="" class="download-icon" />
            <span>App</span>
            <div class="download-tooltip">
              <ul>
                <li class="apk">
                  <a :href="apkUrl" target="_blank" rel="noopener">
                    <img :src="iconApk" alt="" class="dl-link-icon" />
                    Android APK
                  </a>
                </li>
                <li class="ios">
                  <a :href="appStoreUrl" target="_blank" rel="noopener">
                    <img :src="iconApple" alt="" class="dl-link-icon" />
                    Apple Store
                  </a>
                </li>
                <li class="android">
                  <a :href="googlePlayUrl" target="_blank" rel="noopener">
                    <img :src="iconGoogle" alt="" class="dl-link-icon" />
                    Google Play
                  </a>
                </li>
              </ul>
            </div>
          </a>
        </div>
      </div>
    </header>

    <!-- Backgrounds (crossfade) -->
    <div class="bg-layer">
      <div v-for="(slide, idx) in slides" :key="'bg-' + idx" class="bg-item" :class="{ active: currentIndex === idx }">
        <div class="bg-gradient" :class="slide.bgClass"></div>
      </div>
    </div>

    <!-- Main content -->
    <div class="main-content">
      <div class="content-inner">
        <!-- Text column (fade in/out) -->
        <div class="text-col">
          <div v-for="(slide, idx) in slides" :key="'txt-' + idx" class="text-block"
            :class="{ active: currentIndex === idx }">
            <h1 class="slide-title">{{ slide.title }}</h1>
            <p class="slide-subtitle">{{ slide.subtitle }}</p>
            <div class="dl-buttons">
              <a :href="appStoreUrl" class="dl-btn" target="_blank" rel="noopener">
                <img :src="iconApple" alt="" class="dl-btn-icon" />
                <div class="dl-btn-text">
                  <small>Download on the</small>
                  <strong>App Store</strong>
                </div>
              </a>
              <a :href="googlePlayUrl" class="dl-btn" target="_blank" rel="noopener">
                <img :src="iconGoogle" alt="" class="dl-btn-icon" />
                <div class="dl-btn-text">
                  <small>GET IT ON</small>
                  <strong>Google Play</strong>
                </div>
              </a>
              <a :href="apkUrl" class="dl-btn" target="_blank" rel="noopener">
                <img :src="iconApk" alt="" class="dl-btn-icon" />
                <div class="dl-btn-text">
                  <strong>APK</strong>
                  <strong>Download</strong>
                </div>
              </a>
            </div>
          </div>
        </div>

        <!-- Phone column (card flip) -->
        <div class="phone-col">
          <div class="phone-flipper phone-flipper-clickable" :style="flipperStyle" role="button" tabindex="0"
            aria-label="Switch phone preview" @click="onPhoneClick" @keydown.enter.prevent="onPhoneClick"
            @keydown.space.prevent="onPhoneClick" @transitionend="onFlipDone">
            <div class="phone-card phone-front">
              <div class="phone-composite">
                <img :src="slides[displayFront].phone" alt="" class="phone-img" />
              </div>
            </div>
            <div class="phone-card phone-back">
              <div class="phone-composite">
                <img :src="slides[displayBack].phone" alt="" class="phone-img" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Pagination dots -->
    <div class="pagination">
      <span v-for="(slide, idx) in slides" :key="'dot-' + idx" class="dot" :class="{ active: currentIndex === idx }"
        @click="goTo(idx)"></span>
    </div>

    <footer class="next-footer">
      <div class="footer-inner">
        <div class="footer-links">
          <a :href="termsUrl" target="_blank">Terms</a>
          <span class="divider">|</span>
          <a :href="privacyUrl" target="_blank">Privacy</a>
          <span class="divider">|</span>
          <div class="policies-menu" :class="{ open: showPolicies }">
            <a href="javascript:;" class="policies-link" @click.prevent.stop="togglePolicies">Policies
              <img :src="iconChevron" alt="" class="policies-chevron" />
            </a>
            <div class="policies-dropdown" v-show="showPolicies">
              <a :href="abuseUrl" target="_blank" rel="noopener">Sexual Abuse Support</a>
              <a :href="abuseUrl + '#csam'" target="_blank" rel="noopener">Child Safety Policy</a>
            </div>
          </div>
          <span class="divider">|</span>
          <a :href="supportUrl" target="_blank">Support</a>
          <span class="divider">|</span>
          <a :href="aboutUrl" target="_blank">About ChaCha</a>
        </div>
        <!-- <div class="social-links">
          <a href="https://www.facebook.com/nextlv" class="social-btn" target="_blank" rel="noopener">
            <img :src="iconFacebook" alt="Facebook" class="social-icon" />
          </a>
          <a href="https://twitter.com/nextlv" class="social-btn" target="_blank" rel="noopener">
            <img :src="iconTwitter" alt="Twitter" class="social-icon" />
          </a>
          <a href="#" class="social-btn" target="_blank" rel="noopener">
            <img :src="iconGoogleSocial" alt="Google" class="social-icon" />
          </a>
        </div> -->
      </div>
    </footer>
  </div>
</template>

<script>
import logoImg from '../../common/imgs/favicon.png'
import phone1 from '../../common/imgs/phone1-screen.png'
import phone2 from '../../common/imgs/phone2-screen.png'
import phone3 from '../../common/imgs/phone3-screen.png'
import iconApple from '../../common/imgs/icon-apple.svg'
import iconGoogle from '../../common/imgs/icon-google.svg'
import iconApk from '../../common/imgs/icon-apk.svg'
import iconChevron from '../../common/imgs/icon-chevron-down.svg'
import iconFacebook from '../../common/imgs/icon-facebook.svg'
import iconTwitter from '../../common/imgs/icon-twitter.svg'
import iconGoogleSocial from '../../common/imgs/icon-google-social.svg'

var COOLDOWN = 900

// chachaapp.net 下协议页已拍平到根路径（见 app/middlewares/next_flat_path.js），
// 其他域名（nextlv.net / micoworld.net/next 等）仍带 /next 前缀
function getPageBase() {
  var hostname = typeof location === 'undefined' ? '' : location.hostname
  return /chachaapp/i.test(hostname) ? '' : '/next'
}

// terms 是例外：chachaapp.net 的 nginx `location ^~ /terms` 漏了 Host 头，
// /terms.html 到不了正确的域名判断只能 404（见 app/middlewares/next_flat_path.js），
// 所以它在所有域名下都保持 /next/terms.html
var FLAT_PATH_EXCLUDED = ['terms']

function pageUrl(name) {
  var base = FLAT_PATH_EXCLUDED.indexOf(name) === -1 ? getPageBase() : '/next'
  return base + '/' + name + '.html'
}

export default {
  data: function () {
    return {
      logoImg: logoImg,
      iconApple: iconApple,
      iconGoogle: iconGoogle,
      iconApk: iconApk,
      iconChevron: iconChevron,
      iconFacebook: iconFacebook,
      iconTwitter: iconTwitter,
      iconGoogleSocial: iconGoogleSocial,
      showPolicies: false,
      termsUrl: pageUrl('terms'),
      privacyUrl: pageUrl('privacy'),
      supportUrl: pageUrl('support'),
      aboutUrl: pageUrl('about'),
      abuseUrl: pageUrl('sexual-abuse-support'),
      appStoreUrl: 'https://apps.apple.com/app/id6776965488',
      googlePlayUrl: 'https://play.google.com/store/apps/details?id=com.xnext.android',
      apkUrl: 'https://image.nextlv.net/apk/chacha_release.apk',
      currentIndex: 0,
      displayFront: 0,
      displayBack: 1,
      flipDeg: 0,
      locked: false,
      touchStartX: 0,
      touchStartY: 0,
      lastTouchActionTime: 0,
      lastWheelTime: 0,
      slides: [
        { title: 'Fun\nLivestreams', subtitle: 'Watch and broadcast anytime and anywhere.', bgClass: 'bg-slide-1', phone: phone1, phoneClass: 'border-white' },
        { title: 'AUDIO\nHOUSE', subtitle: 'Place To Speak Freely', bgClass: 'bg-slide-2', phone: phone2, phoneClass: 'border-white' },
        { title: 'FREE\nCHAT', subtitle: 'Chat with friends global directly!', bgClass: 'bg-slide-3', phone: phone3, phoneClass: 'border-gray' }
      ]
    }
  },
  computed: {
    flipperStyle: function () {
      return { transform: 'rotateY(' + this.flipDeg + 'deg)' }
    }
  },
  methods: {
    goTo: function (idx) {
      if (idx === this.currentIndex || this.locked) return
      this._switchTo(idx)
    },
    next: function () {
      if (this.locked) return
      this._switchTo((this.currentIndex + 1) % this.slides.length)
    },
    prev: function () {
      if (this.locked) return
      this._switchTo((this.currentIndex - 1 + this.slides.length) % this.slides.length)
    },
    _switchTo: function (idx) {
      this.locked = true

      var showingFront = (this.flipDeg / 180) % 2 === 0
      if (showingFront) {
        this.displayBack = idx
      } else {
        this.displayFront = idx
      }

      this.currentIndex = idx
      this.flipDeg += 180
    },
    onFlipDone: function () {
      this.locked = false
    },
    onWheel: function (e) {
      if (this.locked) return
      var now = Date.now()
      if (now - this.lastWheelTime < COOLDOWN) return
      var absX = Math.abs(e.deltaX)
      var absY = Math.abs(e.deltaY)
      var threshold = 20
      if (absY >= absX && absY > threshold) {
        this.lastWheelTime = now
        if (e.deltaY > 0) this.next(); else this.prev()
      } else if (absX > absY && absX > threshold) {
        this.lastWheelTime = now
        if (e.deltaX > 0) this.next(); else this.prev()
      }
    },
    onTouchStart: function (e) {
      this.touchStartX = e.touches[0].clientX
      this.touchStartY = e.touches[0].clientY
    },
    onTouchEnd: function (e) {
      var dx = e.changedTouches[0].clientX - this.touchStartX
      var dy = e.changedTouches[0].clientY - this.touchStartY
      var threshold = 50
      if (Math.abs(dx) >= Math.abs(dy)) {
        if (dx < -threshold) {
          this.lastTouchActionTime = Date.now()
          this.next()
        } else if (dx > threshold) {
          this.lastTouchActionTime = Date.now()
          this.prev()
        }
      } else {
        if (dy < -threshold) {
          this.lastTouchActionTime = Date.now()
          this.next()
        } else if (dy > threshold) {
          this.lastTouchActionTime = Date.now()
          this.prev()
        }
      }
    },
    onPhoneClick: function () {
      if (Date.now() - this.lastTouchActionTime < 350) return
      this.next()
    },
    togglePolicies: function () {
      this.showPolicies = !this.showPolicies
    },
    onDocumentClick: function (e) {
      var menu = this.$el.querySelector('.policies-menu')
      if (menu && !menu.contains(e.target)) {
        this.showPolicies = false
      }
    },
    onKeydown: function (e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowRight') this.next()
      else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') this.prev()
      else if (e.key === 'Escape') this.showPolicies = false
    }
  },
  mounted: function () {
    document.addEventListener('keydown', this.onKeydown)
    document.addEventListener('click', this.onDocumentClick)
  },
  beforeDestroy: function () {
    document.removeEventListener('keydown', this.onKeydown)
    document.removeEventListener('click', this.onDocumentClick)
  }
}
</script>
